import { CenteredContent } from '../CenteredContent'

export const ShopifyContentWrapper = ({ children }: { children: React.ReactNode }) => (
  <CenteredContent useVH>
    <div className={'flex flex-col items-center justify-center text-center w-3/4 desktop:w-[60%]'}>
      {children}
    </div>
  </CenteredContent>
)
